import Settings from "@/common/Settings"

export type FeedType =
  | "place_created"
  | "visit"
  | "visit_comment"
  | "place_note"
  | "assigned"
  | "revisit_assigned"
  | "route_scheduled"
  | "dispatch"
  | "contact_created"
  | "incident_created"

export interface FeedActor {
  id: string | null
  name: string | null
  image: string | null
  color: string | null
}

export interface FeedPlace {
  id: string
  name: string | null
  address: string | null
  sector: string | null
  lat: number | null
  lng: number | null
  category: string | null
  stage: string | null
  creditCode: string | null
  image: string | null
  image2: string | null
  assignedTo: string | null
  assignedToName: string | null
  assignedToColor: string | null
  revisitAssignedTo: string | null
  revisitAssignedToColor: string | null
  revisitAssignedToName: string | null
}

export interface FeedItem {
  id: string
  type: FeedType
  occurredAt: string
  cursor: string
  actor: FeedActor | null
  place: FeedPlace | null
  title: string | null
  body: string | null
  media: { url: string; kind: string }[]
  meta: Record<string, any>
  commentCount: number
}

export interface FeedFilterValues {
  types: FeedType[]
  agentId: string
  search: string
  before: string
}

/** Filter chips; one chip may cover several event types. */
export const TYPE_GROUPS: { key: string; label: string; types: FeedType[] }[] = [
  { key: "places", label: "Lugares", types: ["place_created"] },
  { key: "contacts", label: "Contactos", types: ["contact_created"] },
  { key: "visits", label: "Seguimientos", types: ["visit"] },
  { key: "comments", label: "Comentarios", types: ["visit_comment", "place_note"] },
  { key: "assignments", label: "Asignaciones", types: ["assigned", "revisit_assigned"] },
  { key: "routes", label: "Rutas", types: ["route_scheduled"] },
  { key: "dispatches", label: "Despachos", types: ["dispatch"] },
  { key: "incidents", label: "Incidentes", types: ["incident_created"] },
]

export const TYPE_STYLE: Record<FeedType, { icon: string; color: string; label: string }> = {
  place_created: { icon: "fa-map-marker-alt", color: "#16a34a", label: "Nuevo lugar" },
  contact_created: { icon: "fa-address-book", color: "#0284c7", label: "Contacto agregado" },
  visit: { icon: "fa-clipboard-check", color: "#2563eb", label: "Seguimiento" },
  visit_comment: { icon: "fa-comment", color: "#7c3aed", label: "Comentario" },
  place_note: { icon: "fa-sticky-note", color: "#7c3aed", label: "Nota" },
  assigned: { icon: "fa-user-check", color: "#d97706", label: "Asignación" },
  revisit_assigned: { icon: "fa-rotate", color: "#d97706", label: "Revisita asignada" },
  route_scheduled: { icon: "fa-route", color: "#0d9488", label: "En ruta" },
  dispatch: { icon: "fa-truck", color: "#ea580c", label: "Despacho" },
  incident_created: { icon: "fa-exclamation-triangle", color: "#dc2626", label: "Incidente" },
}

const isAbsolute = (name: string) => /^(https?:|data:image\/)/i.test(name)

export const thumbUrl = (name?: string | null) => {
  if (!name) return ""
  if (isAbsolute(name)) return name
  return `${Settings.BasePathForAPI}file/getThumbnail?filename=${encodeURIComponent(name)}`
}

export const fullUrl = (name?: string | null) => {
  if (!name) return ""
  if (isAbsolute(name)) return name.replace("/files/thumb/", "/files/")
  const base = Settings.BasePath.endsWith("/") ? Settings.BasePath : Settings.BasePath + "/"
  return `${base}files/${encodeURIComponent(name)}`
}
